import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { DrawState, ProfileDrawProjection, RegistrationState } from '@unicup-ticketing/service';

@Component({
  selector: 'ticketing-draw-item-container',
  imports: [],
  templateUrl: './draw-item-container.component.html',
  styleUrl: './draw-item-container.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DrawItemContainerComponent {
  draw = input.required<ProfileDrawProjection>();
  protected readonly DrawState = DrawState;
  protected readonly RegistrationState = RegistrationState;
}
